'use client'

import type { NavigationMobileProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-header.types'

import classNames from 'classnames'
import { FocusTrap } from 'focus-trap-react'

import {
  NavigationMobileHeader,
  NavigationMobileLevel,
} from '@maestro/commerce-blocks/components/navigation-header'
import { Mask } from '@pearlconvert/ui/components/mask'

import '@maestro/commerce-blocks/components/navigation-header/styles/navigation-mobile.scss'

export default function NavigationMobile(props: NavigationMobileProps) {
  const { closeMenu, shortcuts, isOpen, menu } = props

  return (
    <>
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          clickOutsideDeactivates: true,
          escapeDeactivates: false,
          allowOutsideClick: true,
        }}
      >
        <div
          className={classNames('nav-mobile mobile-only', {
            'nav-mobile--active': isOpen,
          })}
          aria-hidden={!isOpen}
          inert={!isOpen}
        >
          <NavigationMobileHeader />
          <div className="nav-mobile__body">
            <div className="nav-mobile__body-wrapper">
              <NavigationMobileLevel menu={menu} shortcuts={shortcuts} />
            </div>
          </div>
        </div>
      </FocusTrap>
      <Mask isActive={isOpen} onDismiss={closeMenu} />
    </>
  )
}
